export default {
  'selling-price': ['selling_price_management']
}
